<template>
    <div>
        <el-container>
            <el-header id="header-container">
                <div class="header-title" style="flex-shrink: 0; cursor: pointer;" @click="$store.state.tabActive = 0">
                    古钱币综合管理系统</div>
                <div class="header-extend"
                    style="display: flex; width: 100%; flex-direction: row-reverse; align-items: center;">
                    <div class="header-admin"
                        style="margin-right: 20px; display:flex; color: #ffffff; align-items: center;">
                        <img src="@/assets/img/user-icon.png" alt=""
                            style="width: 30px; height: 30px; margin-right: 10px;">
                        <div style="font-size: 14px;">欢迎光临：{{ name }}，</div>
                        <div style="font-size: 14px; cursor: pointer;"
                            @click="menuClick({ permissionId: -1, permissionName: '系统消息', permissionUrl: '/Notify/List' })">
                            [{{ unReadNotify > 0 ? "您有" + unReadNotify + "条未读消息" : "系统消息" }}]，</div>
                        <div style="font-size: 14px; cursor: pointer;" @click="isPassword = true">[修改密码]，</div>
                        <div style="font-size: 14px; cursor: pointer;" @click="outClick()">[点此退出]</div>
                    </div>
                </div>
            </el-header>
            <el-container>
                <el-aside width="200px" id="aside-menu">
                    <el-menu :default-active="$store.state.tabActive + ''" class="el-menu-vertical-demo"
                        :default-openeds="'1'" background-color="#545c64" text-color="#fff" active-text-color="#ffd04b">
                        <template v-for="menu in menus">
                            <el-submenu :key="menu.permissionId" :index="menu.permissionId + ''"
                                v-if="menu.children && menu.children.length > 0">
                                <template slot="title">
                                    <i :class="menu.permissionIcon" style="color: #FFFFFF;"
                                        v-if="menu.permissionIcon"></i><span>{{ menu.permissionName }}</span>
                                </template>
                                <el-menu-item :key="child.permissionId" :index="child.permissionId + ''"
                                    style="padding-left: 30px;" v-for="child in menu.children"
                                    @click="menuClick(child)">
                                    <i :class="child.permissionIcon" style="color: #FFFFFF;"
                                        v-if="child.permissionIcon"></i><span>{{
                    child.permissionName }}</span>
                                    <!-- 专门显示7日上新，7天调价 -->
                                    <span
                                        v-if="(child.permissionId == '1971578772960337922' || child.permissionId == '1971578772960337923' || child.permissionId == '1971579113068060673') && getUnReadCount(child.permissionId) > 0"
                                        style="position: absolute; top: 19px; right: 7px; height: 20px; line-height: 20px; font-size: 12px; min-width: 30px; text-align: center; border-radius: 10px; background-color: #FF0000; color: #FFFFFF; ">{{
                    getUnReadCount(child.permissionId) }}</span>
                                </el-menu-item>
                            </el-submenu>
                            <el-menu-item :key="menu.permissionId" v-else :index="menu.permissionId + ''"
                                @click="menuClick(menu)">
                                <i :class="menu.permissionIcon" style="color: #FFFFFF;"
                                    v-if="menu.permissionIcon"></i><span>{{ menu.permissionName
                                    }}</span>
                            </el-menu-item>
                        </template>
                    </el-menu>
                </el-aside>
                <el-main id="aside-content" style="background-color: #f8f8f9;">
                    <el-tabs v-model="$store.state.tabActive" type="card" @tab-remove="removeTab"
                        style="width: calc(100% - 24px); margin: 7px auto 0px auto;" @tab-click="tabClick">
                        <el-tab-pane :key="tab.permissionId" :label="tab.permissionName" :name="tab.permissionId"
                            v-for="tab in $store.state.tabs"
                            :closable="tab.permissionId == 0 ? false : true"></el-tab-pane>
                    </el-tabs>
                    <!-- <router-view v-slot="{ Component }" :key="$route.fullPath">
                        <keep-alive>
                            <component :is="Component" />
                        </keep-alive>
                    </router-view> -->
                    <keep-alive>
                        <router-view :key="$route.fullPath"></router-view>
                    </keep-alive>
                </el-main>
            </el-container>
        </el-container>
        <!-- 修改密码 -->
        <el-dialog title="修改密码" :visible.sync="isPassword" width="30%" :close-on-click-modal="false">
            <el-form ref="form" :model="passwordForm" label-width="90px">
                <el-form-item label="原始密码">
                    <el-input v-model="passwordForm.oldPassword" type="password"></el-input>
                </el-form-item>
                <el-form-item label="输入新密码">
                    <el-input v-model="passwordForm.newPassword" type="password"></el-input>
                </el-form-item>
                <el-form-item label="确认新密码">
                    <el-input v-model="passwordForm.confirmPassword" type="password"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isPassword = false">取 消</el-button>
                <el-button type="primary" @click="updatePassword()">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 域名更新弹窗 -->
        <el-dialog title="域名更新提示" :visible.sync="urlVisible" width="620px" :close-on-click-modal="false">
            <div class="dialog-content">
                <p class="desc">系统进行安全升级优化，您所使用的域名即将停用，为保证后续访问的稳定，请保存新地址访问。</p>
                <div class="url-text">{{ currentUrl }}</div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="urlVisible = false">关闭</el-button>
                <el-button type="primary" @click="copyUrl">复制地址</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { API, doGet, doPost } from "@/api/api.js"
import verifyMixin from "@/mixins/verify-mixin.js"

export default {
    mixins: [verifyMixin],
    data: function () {
        return {
            currentUrl: "https://chinese-ancient-coin-admin.changpaibeijing.com/",
            urlVisible: false,
            name: "",
            menus: [],
            isPassword: false,
            passwordForm: {
                oldPassword: "",
                newPassword: "",
                confirmPassword: ""
            },
            unReadNotify: 0,
            productUnRead: null,
            dictionaryUnRead: 0,
        }
    },
    methods: {
        copyUrl() {
            const input = document.createElement('input')
            input.value = this.currentUrl
            document.body.appendChild(input)
            input.select()
            document.execCommand('copy')
            document.body.removeChild(input)
            this.$message.success('地址复制成功')
            this.urlVisible = false
        },
        getUnReadCount: function (id) {
            let count = 0;
            if (id == "1971578772960337922" && this.productUnRead && this.productUnRead.newRead > 0) {
                count = this.productUnRead.newRead;
            }
            if (id == "1971578772960337923" && this.productUnRead && this.productUnRead.priceRead > 0) {
                count = this.productUnRead.priceRead;
            }
            if (id == "1971579113068060673" && this.dictionaryUnRead) {
                count = this.dictionaryUnRead;
            }
            return count;
        },
        tabClick: function (tab) {
            this.$store.state.tabActive = this.$store.state.tabs[tab.index].permissionId;
        },
        getData: async function () {
            //this.menus = await doGet(API.TREE.PERMISSION);
            try {
                let dataObj = await doGet(API.PUBLIC.INDEX);
                this.name = dataObj.adminName;
                this.menus = dataObj.menus;
                this.productUnRead = await doGet(API.PRODUCT.UNREAD);
                this.dictionaryUnRead = await doGet(API.DICTIONARY_UNREAD);
            }
            catch (e) { }
        },
        removeTab: function (e) {
            for (var i = 0; i < this.$store.state.tabs.length; i++) {
                if (this.$store.state.tabs[i].permissionId == e) {
                    this.$store.state.tabs.splice(i, 1);
                    this.$store.state.tabActive = this.$store.state.tabs[i - 1].permissionId;
                }
            }
        },
        menuClick: function (menu) {
            var isExist = false;
            for (let i = 0; i < this.$store.state.tabs.length; i++) {
                if (this.$store.state.tabs[i].permissionId == menu.permissionId) {
                    isExist = true;
                    break;
                }
            }
            if (!isExist) {
                this.$store.commit('addTab', menu);
            }
            else {
                this.$store.state.tabActive = menu.permissionId;
            }
            // 7日上新/价格调整
            if (menu.permissionId == "1971578772960337922") {
                if (this.productUnRead) {
                    this.productUnRead.newRead = 0;
                }
            }
            if (menu.permissionId == "1971578772960337923") {
                if (this.productUnRead) {
                    this.productUnRead.priceRead = 0;
                }
            }
            if (menu.permissionId == "1971579113068060673") {
                if (this.dictionaryUnRead) {
                    this.dictionaryUnRead = 0;
                }
            }
        },
        outClick: function () {
            this.$store.state.tabs = [];
            this.$store.state.tabActive = "";
            localStorage.setItem("AUTH-ADMIN", null);
            this.$router.push("/login");
        },
        updatePassword: async function () {
            let resultObj = await doPost(API.PUBLIC.PASSWORD_UPDATE, this.passwordForm);
            if (resultObj.errorCode == 0) {
                this.$message.success(resultObj.errorMessage);
                this.isPassword = false;
            }
            else {
                this.$message.error(resultObj.errorMessage);
            }
        },
        getUnReadNotify: async function () {
            let count = await doGet(API.NOTIFY.COUNT);
            if (this.unReadNotify < count) {
                this.$notify({
                    title: '系统消息',
                    message: '您有新的系统消息，请及时查阅',
                    type: 'warning'
                });
            }
            this.unReadNotify = count;
        },
        updateLastDate: async function () {
            await doGet(API.ADMIN_UPDATE_LASTDATE);
        }
    },
    created: function () {
        this.getData();
        this.getUnReadNotify();
        this.updateLastDate();
        setInterval(() => {
            this.getUnReadNotify();
        }, 10000);
    },
    mounted: function () {
        if (location.href.indexOf("39.97.33.175") >= 0 || location.href.indexOf("localhost") >= 0) {
            this.urlVisible = true;
        }
    },
    watch: {
        "$store.state.tabActive": function () {
            let tab = this.$store.state.tabs.filter((tab) => tab.permissionId == this.$store.state.tabActive)[0];
            this.$router.push({
                path: tab.permissionUrl
            });
        }
    }
}
</script>
<style scoped lang="less">
#header-container,
#aside-content {
    padding: 0px !important;
}

#header-container {
    display: flex;
    justify-content: space-between;
}

.header-title {
    width: 200px;
    background-color: rgba(0, 0, 0, 0.8);
    color: #ffffff;
    height: 60px;
    line-height: 60px;
    padding-left: 20px;
    font-size: 16px;
    font-weight: bold;
}

.header-extend {
    background-color: rgb(84, 92, 100);
    flex-grow: 1;
}

#container-main {
    height: 100vh;
}

#el-container {
    height: calc(100vh - 60px);
}

#aside-menu {
    width: 200px;
    height: calc(100vh - 60px);
    background-color: rgb(84, 92, 100);
    overflow-y: scroll;
    overflow: -moz-scrollbars-none;
    -ms-overflow-style: none;
    scrollbar-width: none;
}

#aside-menu::-webkit-scrollbar {
    width: 0 !important
}

#aside-content {
    width: calc(100vw - 200px);
    height: calc(100vh - 60px);
}

#menu-list {
    width: 200px;
    border: none;
}

#menu-list .el-menu-item {
    width: 200px;
}

.el-menu {
    border-right-width: 0;
}
</style>